import React from "react";
import Form from "../common/Form";
import Section from "../common/Section";
import ScoreFieldset from "./ScoreFieldset";
import PropTypes from "prop-types";
import Fieldset from "../common/Fieldset";
import FieldsetSubHeader from "../common/FieldsetSubHeader";
import Row from "../common/Row";
import Col from "../common/Col";
import Button from "../common/Button";
import moment from "moment";
import DownloadUploadFile from "../common/DownloadUploadFiles";

const SimulatieResultaatForm = (props) => {
    const { disabled,
        simulatieDossier,
        color,
        scores,
        onWijzig,
        totaalGewicht,
        totaalPunten,
        onStartDossier,
        hasUnsavedChanges,
        pdf,
        isPollingDocument,
        onGenerateRapport,
        pdfGegenereerdOp } = props;

    const infrastructuren = simulatieDossier.sportinfrastructurenInDeBuurt.filter(i => i.infrastructuurId !== "00000000-0000-0000-0000-000000000000");

    const nietOntvankelijkTekst1 = "Jouw subsidieaanvraag is waarschijnlijk niet ontvankelijk.";
    const nietOntvankelijkTekst2 = "* Voor het criterium \"bovenlokaliteit\" behaalt jouw project minder dan 2/10.";
    const nietOntvankelijkTekst3 = "* Je antwoordde nee op 1 of meerdere vragen in verband met minimale eisen.";
    const ontvankelijkTekst1 = "Jouw subsidieaanvraag is waarschijnlijk ontvankelijk.";
    const ontvankelijkTekst2 = "* Voor het criterium \"bovenlokaliteit\" behaalt jouw project minstens 2/10.";
    const ontvankelijkTekst3 = "* Je antwoordde positief op alle vragen in verband met minimale eisen.";
    const isIndienenBlocked = moment(simulatieDossier.uitersteIndiendatum) < moment();

    return (
        <Section title="Ga na of jouw dossier ontvankelijk is" color={color}>
            <Form title="Simulator resultaat" name="simulator resultaat">
                <ScoreFieldset
                    scores={scores}
                    disabled={disabled}
                    meerdereInfras={infrastructuren.length > 1}
                    totaalGewicht={totaalGewicht}
                    simulatieDossier={simulatieDossier}
                    bovenLokaliteitPerInfrastructuur={simulatieDossier.bovenlokaliteitHoogsteScore}
                />
                <Fieldset>
                    <FieldsetSubHeader>Eindbeoordeling simulatie</FieldsetSubHeader>
                    {(simulatieDossier.statusSimulatie === 121450001 || simulatieDossier.statusSimulatie == "121450001") ?
                        <p>
                            {nietOntvankelijkTekst1}<br /><br />
                            {(simulatieDossier.scoreBovenlokaliteit < 2) ?
                                nietOntvankelijkTekst2
                                :
                                ""
                            }
                            <br />
                            {(simulatieDossier.minimaleEisenPositief === false) ?
                                nietOntvankelijkTekst3
                                :
                                ""
                            }
                        </p>
                        :
                        <p>{ontvankelijkTekst1}<br /><br />{ontvankelijkTekst2}<br />{ontvankelijkTekst3}</p>
                    }

                    {simulatieDossier.memoNeeAntwoorden && simulatieDossier.memoNeeAntwoorden.length ?
                        <p dangerouslySetInnerHTML={{ __html: simulatieDossier.memoNeeAntwoorden.map(antwoord => { return "* " + antwoord; }).join("<br />") }}/>
                        : ""
                    }
                </Fieldset>
                <Fieldset>
                    <FieldsetSubHeader>Waarschuwing</FieldsetSubHeader>
                    <p>Het resultaat van deze simulator doet onder geen enkele omstandigheid een uitspraak over een subsidieaanvraag en kan enkel en alleen als indicatief worden beschouwd. Een subsidieaanvraag zal steeds worden beoordeeld op basis van de aangeleverde informatie die wordt gevraagd via het door Sport Vlaanderen voorziene online aanvraagformulier conform de procedures en voorwaarden die in het decreet van 5 mei 2017 houdende de ondersteuning van bovenlokale sportinfrastructuur en topsportinfrastructuur en het bijhorende uitvoeringsbesluit zijn geformuleerd.</p>
                </Fieldset>
                <Fieldset title="Simulatierapport">
                    <Row>
                        {simulatieDossier.dossierPDFGegenereerd ?
                            <DownloadUploadFile
                                dossierId={simulatieDossier.id}
                                title="PDF van het simulatiedossier"
                                size={6}
                                tab="simulatiedossier"
                                component=""
                                files={pdf.files}
                                color={color}
                                downloadOnly
                                isPdf />
                            : null}
                        <div className="o-col-6" style={{ paddingTop: '15px' }}>
                            {isPollingDocument ? <p>Even geduld a.u.b.</p> : null}
                            <Button onClick={onGenerateRapport} disabled={isPollingDocument || hasUnsavedChanges || disabled}>Genereer PDF</Button>
                        </div>
                    </Row>
                    <Row>
                        {pdfGegenereerdOp ? <p>Documenten gegenereerd op: {moment(pdfGegenereerdOp).format("DD-MM-YYYY HH:mm")}</p> : ""}
                    </Row>
                </Fieldset>
                <Fieldset>
                    <div className={"c-form__actions"}>
                        <div className="c-error o-col-12">
                            {isIndienenBlocked ? <p className="g-right">Er is nog geen nieuwe aanvraagronde gestart, daarom kan je momenteel geen nieuwe dossiers opstarten.</p> : ""}
                        </div>
                        <Button
                            name="btnWijzig"
                            disabled={disabled}
                            text="Wijzig gegevens"
                            onClick={onWijzig}
                            className="o-col-6" />

                        <Button
                            name="btnStartDossier"
                            disabled={disabled || isIndienenBlocked}
                            text="Start dossier"
                            onClick={onStartDossier}
                            className="o-col-6" />
                    </div>
                </Fieldset>
            </Form>
        </Section>
    );
};

SimulatieResultaatForm.propTypes = {
    disabled: PropTypes.bool,
    scores: PropTypes.array,
    simulatieDossier: PropTypes.object,
    color: PropTypes.string,
    onWijzig: PropTypes.func,
    totaalGewicht: PropTypes.number,
    totaalPunten: PropTypes.number,
    onStartDossier: PropTypes.func,
    hasUnsavedChanges: PropTypes.bool,
    isPollingDocument: PropTypes.bool,
    onGenerateRapport: PropTypes.func.isRequired,
    pdf: PropTypes.object,
    pdfGegenereerdOp: PropTypes.string
};

export default SimulatieResultaatForm;